<!--
 * @Description: 个人中心
 * @Author: xu wei
 * @Date: 2020-03-07 15:43:10
 * @LastEditTime: 2020-06-16 16:24:56
 * @LastEditors: gao shuai
 -->
<template>
  <div class="partinstall">
    <div class="bg_fff">
      <div class="gs_listcontainer">
        <p class="tip_red">通讯密匙</p>
        <p class="mgb10">这是网站与您的充值服务器网关的通讯密匙，建议您不定期更换密匙</p>
        <dl class="clearfix">
          <dt>商户标识</dt>
          <dd>{{baseInfo.merchantMark}}</dd>
        </dl>
        <dl class="clearfix">
          <dt>通讯密钥</dt>
          <dd>{{baseInfo.serverKey}}</dd>
          <span class="mgl20" style="margin-top: 2px;margin-right: -11px;">
            <el-button size="mini" type="primary" @click="changeKey">更换</el-button>
          </span>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseInfo: {
        serverKey: '', // 通讯密钥
        merchantMark: '' // 商户标识
      }
    };
  },
  methods: {
    // 获取用户信息
    getUser() {
      this.$api.home
        .getUserinfo()
        .then((data) => {
          this.baseInfo.serverKey = data.data.secretKey;
          this.baseInfo.merchantMark = data.data.uuid;
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    },
    // 更换密钥
    changeKey() {
      this.$api.personCenter
        .changeKey()
        .then((data) => {
          if (data.status === 200) {
            this.$messageSuccess('更新成功！');
            this.getUser();
          }
        })
        .catch((err) => {
          this.$messageError(err.message);
        });
    }
  },
  created() {
    this.getUser();
  }
};
</script>

<style lang="scss" scoped>
.tip_red {
  color: #3c8dbc;
  padding: 10px 0px;
  font-weight: bold;
  font-size: 15px;
}
.gs_listcontainer {
  padding-bottom: 20px;
  margin-left: 20px;
  .clearfix {
    border: 1px solid #d9edf7;
    width: 95%;
    margin-bottom: 1px;
    padding-left: 0px;
    .mgl20 {
      float: right;
    }
    dt {
      background-color: #d9edf7;
      padding-right: 10px;
    }
    dd {
      padding-top: 5px;
    }
  }
}
.mg2 {
  float: right;
  margin-top: -20px;
}
.opeartbox {
  border: 1px solid #00bcd4;
  width: 97%;
}
.line_tip {
  color: #999;
  font-size: 14px;
  margin-left: 20px;
}
.right {
  float: right;
  margin-right: 4%;
}
.el-form-item {
  margin-bottom: 10px;
}
.editserverBox {
  padding-left: 20px;
  .list {
    margin-bottom: 10px;
    .tit {
      float: left;
      width: 90px;
      height: 32px;
      line-height: 32px;
    }
    .content {
      float: left;
      width: 250px;
    }
  }
  .serveList {
    li {
      position: relative;
      float: left;
      width: 100px;
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-right: 15px;
      margin-bottom: 10px;
      overflow: hidden;
      .tit {
        background: #3c8dbc;
        color: #fff;
        height: 22px;
        line-height: 22px;
      }
      .numberbox {
        height: 25px;
        line-height: 25px;
        color: green;
        font-size: 13px;
      }
      &:hover {
        .mask {
          top: 0;
        }
      }
      .mask {
        position: absolute;
        transition: top 0.3s;
        top: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.8);
        color: #fff;
        cursor: pointer;
        line-height: 50px;
      }
    }
  }
}
</style>
